
<template>
  <div>
    <AgentCommissionRecord :isReport="true"></AgentCommissionRecord>
  </div>
</template>
<script type="text/javascript">
import AgentCommissionRecord from '@/Adm/AgentCommission/AgentCommissionRecord'
  export default{
    name: 'ReportSr',
    components:{
      AgentCommissionRecord
    }
  }
</script>


// WEBPACK FOOTER //
// src/Dw/containers/ReportAgentCommission.vue